// This file is AUTOGENERATED, do not edit it manually!!!

export const customFields = {
    add_own_options: 'Voeg uw eigen opties toe',
    allActivities: 'Activiteit (taak, probleem, verzoek)',
    AllActivities_group_title: 'Activiteit (taak, probleem, verzoek) velden',
    batch_mark_as_optional: 'Als optioneel markeren',
    batch_mark_as_required: 'Als verplicht markeren',
    boolean_field_type: 'Aankruisvak (ja/nee)',
    create_cf: 'Maak een aangepast veld aan',
    custom_field_could_not_be_deleted: 'Aangepast veld \"{0}\" kan niet worden verwijderd',
    custom_field_could_not_be_removed: 'Aangepast veld \"{0}\" kan niet worden verwijderd',
    custom_field_readonly_warning: 'Dit aangepaste veld kan alleen worden bekeken met uw toegangsniveau. Neem contact op met de beheerder om wijzigingen aan te brengen.',
    customer: 'Klant',
    Customer_group_title: 'Klantenvelden',
    default_field_name: 'Nieuw veld',
    delete_field_title: 'Veld \"{0}\" verwijderen?',
    everywhere: 'Overal',
    expense: 'Uitgave',
    Expense_group_title: 'Uitgavevelden',
    field_is_used_in_formula: '1#Dit aangepaste veld wordt gebruikt in het aangepaste formuleveld {0}#Dit aangepaste veld wordt gebruikt in de aangepaste formulevelden {0}',
    field_non_editable_portfolio_restriction: 'Dit aangepaste veld behoort niet tot projecten in de <b>{0}</b> portefeuille',
    field_non_editable_without_portfolio_restriction: 'Dit aangepaste veld behoort niet tot projecten <b>{0} zonder portefeuille</b>',
    field_non_editable_wrong_space: 'Dit aangepaste veld behoort niet tot <b>{0}</b> space',
    fields_plural: '1#{0} veld#{0} velden',
    formula_description: 'Voor het maken van formules kunt u de veldtypen Number, Money en Hours en de bewerkingen + - * / gebruiken. U kunt ook haakjes toevoegen om samengestelde formules te maken:',
    formula_example: 'Bijvoorbeeld:',
    formula_field_type: 'Formule',
    hyperlink_field_type: 'Hyperlink',
    issue: 'Probleem',
    Issue_group_title: 'Probleemvelden',
    limitReachedMessage: 'Sorry, u heeft het maximum aantal aangepaste velden van het gekozen type bereikt dat u kunt toevoegen.',
    mark_as_optional_feedback: '1#{0} aangepast veld is succesvol gemarkeerd als optioneel#{0} aangepaste velden zijn succesvol gemarkeerd als optioneel',
    mark_as_optional_feedback_failure: '1#{0} aangepast veld kon niet als optioneel worden gemarkeerd vanwege het type (keuzelijst, formule of aankruisvak)#{0} aangepaste velden konden niet als optioneel worden gemarkeerd vanwege hun type (keuzelijst, formule of aankruisvak)',
    mark_as_required_feedback: '1#{0} aangepast veld is succesvol gemarkeerd als verplicht#{0} aangepaste velden zijn succesvol gemarkeerd als verplicht',
    mark_as_required_feedback_failure: '1#{0} aangepast veld kon niet als verplicht worden gemarkeerd vanwege het type (keuzelijst, formule of aankruisvak)#{0} aangepaste velden konden niet als verplicht worden gemarkeerd vanwege hun type (keuzelijst, formule of aankruisvak)',
    msg_deleteUsedValue: 'Deze waarde wordt gebruikt in {0} {1}',
    msg_entities_portfolioRemoved: 'Dit veld is niet langer beschikbaar voor de entiteiten die zijn opgenomen in de uitgesloten portefeuilles.',
    msg_entities_spaceRemoved: 'Dit veld is niet langer beschikbaar voor de entiteiten die zijn opgenomen in de uitgesloten spaces.',
    msg_lead_to: 'Wilt u de wijzigingen opslaan?',
    msg_restrictionsAdded: 'Dit aangepaste veld wordt beperkt tot een portefeuille.',
    msg_restrictionsRemoved: 'Dit aangepaste veld is niet langer beperkt tot een portefeuille.',
    msg_unportfolioedOff: 'Dit aangepaste veld is niet beschikbaar voor projecten die niet zijn opgenomen in portefeuilles.',
    msg_valueRemoved: 'Elk item dat uit de lijst is uitgesloten, wordt permanent verwijderd.',
    no_portfolio: 'Zonder portefeuille',
    nowhere: 'Nergens',
    numeric_field_type: 'Nummer',
    other_portfolios: 'Andere portefeuilles',
    portfolio: 'Portefeuille',
    Portfolio_group_title: 'Portefeuillevelden',
    project: 'Project',
    Project_group_title: 'Projectvelden',
    readonly_warning_no_access_to_portfolios: 'U kunt dit aangepaste veld alleen bekijken omdat het is gekoppeld aan portefeuilles waarvoor u geen toegang heeft.',
    remove_field_description: 'Het aangepaste veld blijft beschikbaar in de bedrijfsinstellingen.',
    remove_field_title: 'Wilt u het aangepaste veld \"{0}\" verwijderen uit \"{1}\"?',
    request: 'Verzoek',
    Request_group_title: 'Verzoekvelden',
    required_fileds_not_filled: '1#{0} verplicht veld is niet ingevuld#{0} verplichte velden zijn niet ingevuld',
    select_from: 'Selecteer aangepast veld',
    spaces_field_label: 'Spaces',
    spaces_field_section_title: 'Beschikbaar in spaces',
    task: 'Taak',
    Task_group_title: 'Taakvelden',
    text_add: 'Toevoegen',
    text_add_new_item: 'Een nieuw item toevoegen of gebruik Ctrl+V om een lijst met items te plakken',
    text_add_portfolio: 'Portefeuille toevoegen',
    text_addDescription: 'Beschrijving toevoegen',
    text_all_objects: 'Alle objecten',
    text_available_in: 'Portefeuilles voor het veld',
    text_create_new_field: 'Aangepast veld toevoegen',
    text_currentIdentity: 'Start vanaf',
    text_custom_field_for: 'Veld voor',
    text_delete: 'Veld verwijderen',
    text_delete_permanently: 'Permanent verwijderen',
    text_deleteValue: 'Waarde verwijderen',
    text_edit: 'Veld bewerken',
    text_empty_page_part1: 'Wilt u meer flexibiliteit om uw gegevens bij te houden en te rapporteren?',
    text_empty_page_part2: 'Voeg uw eigen velden toe voor projecten, taken, gebruikers en meer...',
    text_error_title: 'De bewerking kon niet worden voltooid.',
    text_field_type: 'Tekst',
    text_fieldName: 'Veldnaam',
    text_fieldType: 'Veldtype',
    text_filter: 'Aangepaste velden voor',
    text_include_in_unportfolioed_projects: 'Laat het ook zien voor projecten die niet zijn opgenomen in portefeuilles',
    text_isIdentity: 'Automatisch ophogen',
    text_isNumeric: 'Geen decimalen weergeven',
    text_isRequired: 'Vereist',
    text_place_plural: '1#plaats#plaatsen',
    text_remainingValuesTemplate: 'toon \"{0}\" verborgen items bovenaan de lijst',
    text_remove: 'Verwijderen',
    text_restricted_by_portfolio: 'Beperkt door portfolio',
    text_set_restrictions: 'Toon dit veld alleen voor projecten die zijn opgenomen in geselecteerde portfolio\'s',
    textarearich_field_type: 'Paragraaf tekst (met opmaak)',
    timeEntry: 'Tijdsinvoer',
    TimeEntry_group_title: 'Tijdsinvoer velden',
    tooltip_disable_batch: 'U kunt het aangepaste veld alleen bekijken met uw toegangsniveau. Neem contact op met de beheerder om wijzigingen aan te brengen.',
    tooltip_everywhere: '<b>Overal</b> - het aangepaste veld heeft geen zichtbaarheidsbeperkingen.',
    tooltip_nowhere: '<b>Nergens</b> - het aangepaste veld is nergens opgenomen.',
    tooltip_other_portfolios: '<b>Andere portfolio\'s</b> - verwijst naar portfolio\'s waarvoor u niet de nodige rechten hebt.',
    tooltip_portfolio_and_without_part1: '<b>Naam van portfolio, </b>',
    tooltip_portfolio_and_without_part2: '<b>Zonder portfolio</b> - het aangepaste veld is opgenomen in entiteiten in geselecteerde portfolio\'s en entiteiten zonder portfolio\'s.',
    tooltip_portfolio_name: '<b>Naam van portfolio</b> - het aangepaste veld is opgenomen in geselecteerde portfolio\'s.',
    tooltip_without_portfolio: '<b>Zonder portfolio</b> - het aangepaste veld is opgenomen in entiteiten zonder portfolio\'s.',
    unknown_portfolio_description: 'Verwijst naar portfolio\'s waarvoor u niet de nodige rechten hebt.',
    use_cfs_options: 'Gebruik aangepast veld als bron van opties',
    use_own_options: 'Gebruik uw eigen opties',
    user: 'Gebruiker',
    User_group_title: 'Gebruikersvelden',
    validation_error_InvalidBracketsNumber: 'Ongeldig gebruik van haakjes',
    validation_error_InvalidField: 'Ongeldige veldinvoer. Het veld \"{0}\" bestaat niet.',
    validation_error_InvalidOperation: 'Ongeldig gebruik van wiskundige bewerkingen. Alleen de operators ‘+’, ‘-’, ‘*’ en ‘/’ zijn toegestaan.',
    validation_error_InvalidSymbol: 'Ongeldig gebruik van symbolen',
    validation_error_MismatchedInput: 'Onvolledige formule. Zorg ervoor dat alle symbolen en operators worden verstrekt om een geldige formule te maken.',
    validation_error_Unknown: 'Ongeldige formule-indeling. De formule die u heeft ingevoerd, heeft een ongeldige indeling en kan niet succesvol worden geparseerd.',
    visibility_title: 'Zichtbaarheid',
    warning_linked_global_field_activities: 'Wijzigingen in dit aangepaste veld hebben invloed op activiteiten in meerdere spaces.',
    warning_linked_global_field_expenses: 'Wijzigingen in dit aangepaste veld hebben invloed op uitgaven in meerdere spaces.',
    warning_linked_global_field_projects: 'Wijzigingen in dit aangepaste veld hebben invloed op projecten in meerdere spaces.',
    warning_linked_global_field_time: 'Wijzigingen in dit aangepaste veld hebben invloed op tijdsinvoeren in meerdere spaces.',
    warning_wont_visible_without_space: 'Het aangepaste veld is niet zichtbaar voor gebruikers totdat het aan de space is toegevoegd.',
};
